/**
 * Browse Controller
 *
 * @copyright 2016
 * @author Kevin Dench <kevin.dench@intellidata.net>
 * @author Won Ryu <won.ryu@intellidata.net>
 */
import angular from 'angular';
import sidebarUrl from './../sidebar/sidebar.html';
import selectedFiltersUrl from '../selected-filters/selected-filters.component.html';

/* @ngInject */
export default function BrowseComponent($scope, $rootScope, $location, $timeout, $uibModal, $translate, $q, $sce, $window, CacheService, DefinitionParameterApiService,
                                        IconFormatterService, AllDefinitionsCacheService, BrowseService, NavigationService,
                                        NotifyingService, PromoSpaceApiService, SleuthService, DefinitionModelService,
                                        ImageProcessorService, PartCountFormatterService, ContainerInfoApiService, ParametricSearchService, APP_ROUTES) {

    $scope.isBrowseCtrl = true;
    $scope.isTechnologyCtrl = false;
    $scope.isHomeCtrl = false;
    $scope.isDistributorCtrl = false;

    $scope.sideBarUrl = sidebarUrl;
    $scope.selectedFiltersUrl = selectedFiltersUrl;

    /**
     * @var isProductsOpened
     * @type {boolean}
     * @deprecated
     */
    $scope.isProductsOpened = false;

    /**
     * @var isParametersOpened
     * @type {boolean}
     * @deprecated
     */
    $scope.isParametersOpened = true;

    /**
     * @var pageSize
     * @type {number}
     */
    $scope.pageSize = 20;

    /**
     * @var currentPage
     * @type {number}
     */
    $scope.currentPage = 1;

    /**
     * @var definitionNameBreadcrumb
     * @type {null}
     */
    $scope.definitionNameBreadcrumb = null;

    /**
     * @var isCardDataCollapsed
     * @type {boolean}
     */
    $scope.isCardDataCollapsed = false;

    /**
     * @var expandedClass
     * @type {boolean}
     */
    $scope.expandedClass = false;

    /**
     * @var collapsedClass
     * @type {boolean}
     */
    $scope.collapsedClass = true;

    /**
     * @var toggledButtonState
     * @type {string}
     */
    $scope.toggledButtonState = 'label__cta__collapseButton';

    /**
     * Definition from the previous page, single definition
     * @var definition
     * @type {object}
     */
    $scope.definition = CacheService.getDefinition();

    /**
     * Indicates if the definition has visualization data
     * @var hasVisualization
     * @type {boolean}
     */
    $scope.hasVisualization = false;

    /**
     * @var promoSpace
     * @type {object}
     */
    PromoSpaceApiService.getPromosBySize('TALL', function (promos) {
        $scope.promoSpace = promos[Math.floor(Math.random() * promos.length)];
    });

    /**
     * @var filteredDefinition
     * @type {object}
     */
    $scope.filteredDefinition = CacheService.getFilteredDefinition();

    /**
     * Watcher for <code>$locationChangeSuccess</code>
     *
     * This is used as a wrapper to correctly time the syncing of a definition
     *
     * @param event
     * @param newUrl
     * @param oldUrl
     * @param newState
     * @param oldState
     */
    $scope.$on('$locationChangeSuccess', function (event, newUrl, oldUrl) {
        if (SleuthService.getSleuthData() !== undefined) {
            // Commented out for when user searched for uniquePn. Updated TechnologyService.js to remove
            // detectedUniqueParts if user selected different definition. Commented out on 9/6/2018 if it doesn't
            // cause any problem by 3/6/2018 remove it.
            // if(SleuthService.getSleuthData().detectedUniqueParts !== undefined) {
            //     SleuthService.getSleuthData().detectedUniqueParts.length = 0;
            // }
            SleuthService.getSleuthData().message = {type: undefined, text: ''};
        }
        console.log('BrowseComponent');
        NavigationService.syncSleuth(oldUrl);
        NavigationService.syncDefinition($location.search().id);
        $scope.init();
    });

    /**
     * Handle the click of a breadcrumb
     * This provides a link-like functionality to re-filter the current definition using the clicked breadcrumb
     *
     * @param id
     *
     * @return void
     */
    $scope.handleBreadcrumbClick = function (id) {
        $location.search('id', id);
        NavigationService.syncDefinition($location.search().id);
        if (id === 0) {
            NavigationService.closeMenu();
        }
        $scope.init();
    };

    /**
     * Controller constructor-like initialization
     * This method sets all the default values needed when this controller is called for the first time.
     */
    $scope.init = function () {
        $scope.definition = CacheService.getDefinition();

        if ($scope.definition !== undefined && $scope.definition !== null && $scope.definition.id === 0) {
            NavigationService.closeMenu();
        }
        $scope.filteredDefinition = CacheService.getFilteredDefinition();
        if (CacheService.getParentDefinition() !== undefined && CacheService.getParentDefinition() !== null &&
            CacheService.getParentDefinition().length > 0) {
            $scope.previousDefinition = CacheService.getParentDefinition()[CacheService.getParentDefinition().length - 1];
        } else {
            $scope.previousDefinition = undefined;
        }
        $scope.parentDefinitions = CacheService.getParentDefinition();

        ImageProcessorService.processImagesAndDefinitions(null, $scope.definition);
        AllDefinitionsCacheService.setDefinitionParamRange($scope.definition);

        if ($scope.definition !== undefined) {
            $scope.totalItems = $scope.definition.childDefinitions.length;
        } else {
            $scope.totalItems = 0;
        }

        if (!$scope.previousDefinition) {
            $scope.previousDefinition = {};
            $scope.previousDefinition.displayNames = [{
                language: 'ENGLISH',
                display: $translate.instant('browse__backToAllProducts').valueOf()
            }];
        }

        // Don't really have to worry about this, because of how CacheService sets it up, but better safe.
        if ($scope.definition !== undefined) {
            for (var i = 0; i < $scope.definition.childDefinitions.length; i++) {
                PartCountFormatterService.formatPartCount($scope.definition.childDefinitions[i]);
            }
        }

        $scope.hasVisualization = false;
        // only display Visualization data for definitions under Capacitors.
        if (!SleuthService.getSleuthData() && $scope.parentDefinitions !== undefined) {
            $scope.parentDefinitions.map(function (def) {
                if (def.id === 1) {
                    $scope.hasVisualization = true;
                }
            });
        }
        if (!SleuthService.getSleuthData() && $scope.definition !== undefined && $scope.definition.id === 1) {
            $scope.hasVisualization = true;
        }

        if ($scope.definition !== undefined && ($scope.definition.childDefinitions.length === undefined ||
            $scope.definition.childDefinitions.length == 0)) {
            $timeout(
                function () {
                    $scope.$apply(function () {
                        $location.path('/browsing/technology').search('id', CacheService.getDefinition().id);
                    });
                },
                10
            );
        }
    };

    /*
    Check if we have a current context. If we don't have a definition, it's probably on a fresh load, so we need to
    call the DefinitionModelService, which provides an initial call to the REST API and sets the initial values we need.
     */
    if (CacheService.getDefinition()) {
        $scope.init();
    } else {
        DefinitionModelService.getModelInit();
    }

    $scope.handleSleuthChanges = function () {
        if ($location.path() === APP_ROUTES.BROWSING.path) {
            $scope.init();
        }
    };

    // Subscribe to changes in the sleuth.
    NotifyingService.subscribeToSleuthChanges($scope, $scope.handleSleuthChanges);
    // Subscribe to the event when the model service is done initializing.
    NotifyingService.subscribeToModelServiceInit($scope, $scope.init);

    /**
     * Choose Range Icon
     *
     * Pick an icon based on the range name, for now these are hardcoded.
     *
     * @param rangeName
     * @returns {*}
     */
    $scope.chooseRangeIcon = function (rangeName) {
        return IconFormatterService.chooseParameterIcon(rangeName);
    };

    /**
     * Fetch previous
     *
     * This is bound to the "Back to XXX" button in the UI. When the user navigates back we need to store the current
     * definition. Using that current Definition we pass it in, as well as the previous one to the
     * <code>BrowseService</code>'s
     * <code>handleDefinitionParent()</code> method. This will return a <code>definition</code>,
     * <code>parentDefinition</code>, and a <code>definitionNameBreadcrumb</code> in the form of an object.
     *
     * @param current
     */
    $scope.fetchPrevious = function (current) {
        $translate('browse__backToAllProducts', 'en').then(function (allProductsText) {
            var display = ContainerInfoApiService.getDisplayName($scope.previousDefinition, CacheService.getConfigurationInfo().language);

            if (display !== allProductsText.valueOf()) {
                var uiElement = BrowseService.handleDefinitionParent(current, $scope.previousDefinition);
                $scope.definition = uiElement.definition;
                if ($scope.definition.id === 0) {
                    NavigationService.closeMenu();
                }
                CacheService.storeDefinition($scope.definition);
                $scope.previousDefinition = uiElement.parentDefinition;

                DefinitionParameterApiService.getDefinitionParameters(current.id, function (definitionParameters) {
                    $scope.definitionParameters = definitionParameters;
                });

                if ($scope.previousDefinition === undefined) {
                    $scope.previousDefinition = {};
                    $scope.previousDefinition.displayNames = [{
                        language: 'ENGLISH',
                        display: allProductsText.valueOf()
                    }];
                }
            } else {
                $timeout(
                    function () {
                        $scope.$apply(function () {
                            $location.path('/');
                            $location.search('id', null);
                        });
                    },
                    10
                );
            }
            NotifyingService.closeMessageNotification();
        });
    };

    /**
     * Traverse
     *
     * The antithesis of the Fetch Previous method. This method navigates <em>down</em> the definition tree. So it
     * needs the current definition as well as the parent definition. Where it stores those before navigating.
     *
     * @param parent
     * @param current
     */
    $scope.traverse = function (parent, current) {
        // If there aren't children, direct to technology page.
        var updatedDef = NavigationService.findNextDefinition(current, parent);
        current = updatedDef.current;
        parent = updatedDef.parent;
        if (current.childDefinitions.length !== undefined && current.childDefinitions.length > 0) {
            AllDefinitionsCacheService.setDefinitionParamRange(current);

            var uiElement = BrowseService.handleDefinitionChild(current, parent);
            if (parent.id === 0) {
                NavigationService.openMenu();
            }
            $scope.definition = uiElement.definition;
            $location.search('id', $scope.definition.id);
            $scope.previousDefinition = uiElement.parentDefinition;
            $scope.definitionNameBreadcrumb = uiElement.definitionNameBreadcrumb;

            DefinitionParameterApiService.getDefinitionParameters($scope.definition.id, function (definitionParameters) {
                $scope.definitionParameters = definitionParameters;
            });

            $window.scrollTo(0, 0); // [CE-258] Simulate a page refresh
        } else {
            CacheService.storeDefinition(current);
            //Break reference to not update browsing ui when goes to technology page
            $scope.parentDefinitions = $scope.copyParentDefinition();
            CacheService.storeParentDefinition(parent);
            $timeout(
                function () {
                    $scope.$apply(function () {
                        $location.path('/browsing/technology').search('id', CacheService.getDefinition().id);
                    });
                },
                10
            );
        }
        NotifyingService.closeMessageNotification();
    };

    /**
     * Copy Parent Definition
     *
     * Copy the parent definition from the <code>CacheService</code> and return the copy in the form of an array.
     *
     * @returns {Array}
     */
    $scope.copyParentDefinition = function () {
        var copiedParentDefinitions = [];
        CacheService.getParentDefinition().forEach(function (parentDefinition) {
            copiedParentDefinitions.push(parentDefinition);
        });
        return copiedParentDefinitions;
    };

    /**
     * Method to define whether the Products sidebar is open, or not
     * @deprecated
     */
    $scope.openProducts = function () {
        $scope.isProductsOpened = true;
        $scope.isParametersOpened = false;
    };

    /**
     * Method to define whether the Parameters sidebar is open or not
     * @deprecated
     */
    $scope.openParameters = function () {
        $scope.isProductsOpened = false;
        $scope.isParametersOpened = true;
    };

    /**
     * Page Change Handler
     * This handler is for the pagination directive, and is fired whenever the user clicks a new page.
     * @param num
     */
    $scope.pageChangeHandler = function (num) {
        console.log('going to page ' + num);
    };

    /**
     * Toggle Extra Card Data
     *
     * This collapses or expands the data on each of the cards, by adding a class, or removing it.
     */
    $scope.toggleExtraCardData = function () {
        var cards = document.getElementsByClassName('card');

        if ($scope.isCardDataCollapsed) {
            for (let i = 0; i < cards.length; i++) {
                angular.element(cards[i]).removeClass('collapsed');
            }

            $scope.isCardDataCollapsed = !$scope.isCardDataCollapsed;
            $scope.expandedClass = !$scope.expandedClass;
            $scope.collapsedClass = !$scope.collapsedClass;
            $scope.toggledButtonState = 'label__cta__collapseButton';
        } else {
            for (let i = 0; i < cards.length; i++) {
                angular.element(cards[i]).addClass('collapsed');
            }

            $scope.isCardDataCollapsed = !$scope.isCardDataCollapsed;
            $scope.expandedClass = !$scope.expandedClass;
            $scope.collapsedClass = !$scope.collapsedClass;
            $scope.toggledButtonState = 'label__cta__expandButton';
        }
    };

    /**
     * Remove Sleuth Data
     *
     * Shortcut method to remove sleuth data, for the purposes of the user navigating to certain points in the site.
     */
    $scope.removeSleuthData = function () {
        SleuthService.removeSleuthData();
    };

    /**
     * Clear Search Bar
     *
     * Shortcut method to clear the sleuth input.
     */
    $scope.clearSearchBar = function () {
        CacheService.storeOriginalQueryInput(undefined);
    };

    /**
     * Handle Home Click
     *
     * Handles the redirection of linking home for mobile especially.
     */
    $scope.handleHomeClick = function () {
        $location.path('/');
    };

    $scope.displayRangeName = function (range) {
        if (CacheService.getConfigurationInfo() !== undefined) {
            return ContainerInfoApiService.getDisplayName(range, CacheService.getConfigurationInfo().language);
        } else {    // Default is English
            return ContainerInfoApiService.getDisplayName(range, 'ENGLISH');
        }
    };

    $scope.displayDefinitionName = function (definition) {
        if (definition === undefined) {
            return '';
        }
        if ($sce.valueOf(definition.displayName) === $translate.instant('browse__backToAllProducts').valueOf()) {
            return $translate.instant('browse__backToAllProducts').valueOf();
        }
        if (CacheService.getConfigurationInfo() !== undefined) {
            var displayName = ContainerInfoApiService.getDisplayName(definition, CacheService.getConfigurationInfo().language);
            if (displayName === null) {     // Default to English
                return ContainerInfoApiService.getDisplayName(definition, 'ENGLISH');
            } else {
                return displayName;
            }
        }
    };

    $scope.dismissModal = function () {
        $modalInstance.dismiss('cancel');
    };

    $scope.getPartCountLabelByDefinition = function (definition) {
        return PartCountFormatterService.getLabelByDefinition(definition);
    }
}
